import { AfterViewInit, Component, EventEmitter, Inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ApiService } from 'app/modules/shared/services/api.service';
import { AlertMessage } from 'app/shared/utils/alertMessage';
import { CryptoService } from 'app/shared/utils/crypto.service';
import * as moment from 'moment';
import { RolePipePipe } from '../../user-details-dialog/role-pipe.pipe';

@Component({
  selector: 'app-basic-vectoring-user-table',
  templateUrl: './basic-vectoring-user-table.component.html',
  styleUrls: ['./basic-vectoring-user-table.component.scss']
})
export class BasicVectoringUserTableComponent implements AfterViewInit, OnInit {
  //SG-7046 start
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  dataSource: MatTableDataSource<[]>;
  displayedColumns: string[] = [];
  @Input() data: any = [];
  @Input() iscenterFlag: any;
  @Input() tooltip: any;
  @Input() fix: any;
  @Output() teamsList: EventEmitter<any> = new EventEmitter();
  columns: any = [];
  message: any;
  dateType = 'day';
  colName: string;
  pageSize = 5;
  duplicate = false;
  @Output() rowClicked = new EventEmitter();
  constructor(
    public dialogRef: MatDialogRef<BasicVectoringUserTableComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private api: ApiService,
    private router: Router,
    private crypto: CryptoService
  ) { }

  ngAfterViewInit() {
    if (this.dataSource) {
      this.dataSource.paginator = this.paginator;
    }
  }
  getData(e, duplicate) {
    debugger;
    if (duplicate) {
      this.data = [];
      this.dataSource = new MatTableDataSource([]);
      this.message = undefined;
      let key = 'usageType=';
      if (this.dialogData.dateParameter == 'PracticeSet') {
        key = e.type.toLowerCase() + '=';
      }
      this.api.get(this.dialogData.api + (e.date ? e.date : (key + e.type.toLowerCase()))).subscribe(success => {
        if (success && success.length > 0) {
          this.message = undefined;
          this.duplicate = true;
          this.data = success.map(data => data =
          {
            fullName: (data.firstName && data.firstName.trim() !== '') ? (data.firstName ? data.firstName : '') + (data.lastName ? ' ' + data.lastName : '') : data.username,
            email: data.email ? data.email : '',
            nickname: new RolePipePipe().transform(data, "Guest") ? data.username : (data.email ? "" : data.username),
            username: new RolePipePipe().transform(data, "Guest") ? "" : (data.email ? data.username : ""),
            // active: moment(data.active).format('MMMM d, YYYY')
            active: moment(data.active).format('LL')
          });

          this.setData();
        } else {
          this.message = 'No data found';
        }
      }, err => {
        this.getError(err);
      });
    }
  }

  async setData() {
    debugger;
    this.displayedColumns = [];
    this.columns = [];
    Object.keys(this.data[0]).map((ob: any) => {
      if (ob != 'color' && (this.data[0][ob] != null && !(this.data[0][ob].hide))) {
        this.displayedColumns.push(ob);
        const key = ob.split(/(?=[A-Z])/);
        this.columns.push({ colDef: ob, name: key[0] + ' ' + (key[1] ? key[1] : '') });
      }

    });
    if (this.paginator) {
      this.paginator.firstPage();
    }
    this.pageSize = 5;
    for (let i = 0; i < this.data.length; i++) {

      if (this.data[i].email) {
        this.data[i].emailDec = this.crypto.isProbablyEncrypted(this.data[i].email) ? await this.crypto.decryptData(this.data[i].email) : this.data[i].email;
      }

      if (this.data[i].username) {
        this.data[i].usernameDec = this.crypto.isProbablyEncrypted(this.data[i].username) ? await this.crypto.decryptData(this.data[i].username) : this.data[i].username;
      }

      if (this.data[i].nickname) {
        this.data[i].nicknameDec = this.crypto.isProbablyEncrypted(this.data[i].nickname) ? await this.crypto.decryptData(this.data[i].nickname) : this.data[i].nickname;
      }

      if (this.data[i].fullName) {
        this.data[i].fullName = this.crypto.isProbablyEncrypted(this.data[i].fullName) ? await this.crypto.decryptData(this.data[i].fullName) : this.data[i].fullName;
      }
    }
    this.dataSource = new MatTableDataSource(this.data.slice(0, 5));
    this.dataSource.paginator = this.paginator;
  }

  getColName(col) {
    this.colName = col;
  }

  redirection(e) {
    //**************  SG-7218 start *****************
    localStorage.removeItem('updateDate');
    this.dialogRef.close();
    let missionData = localStorage.getItem('selectedApp');
    let selectedApp = JSON.parse(missionData);
    let appData = { ...selectedApp, levelType: this.dialogData.levelType.levelType, lessonType: this.dialogData.levelType.lessonType };
    localStorage.setItem("selectedApp", JSON.stringify(appData));
    let username = e.username == "" ? e.nickname : e.username;
    localStorage.setItem('nickName', username);
    this.router.navigate(['main/user/details/basic/levelwise', username, this.dialogData.levelType.levelType]).then(() => {
      this.api.addRoute(0, username);
    });
    //**************  SG-7218 end *****************

    // this.router.navigate([this.dialogData.rediretionUrl, e[this.dialogData.redirectionKey]]);

  }
  applyFilter(event: Event) {
    if (this.dataSource && this.data.length > 0) {
      const filterValue = (event.target as HTMLInputElement).value;
      this.dataSource.filter = filterValue.trim().toLowerCase();
    }
  }
  closeDialog() {
    localStorage.removeItem('updateDate')
    this.dialogRef.close()
  }
  getError(err) {
    if (err.status == 401) {
      this.api.notifyInfo(AlertMessage.exitingCurrentSession);
      this.api.logmeout();
    }
  }

  ngOnInit() {
    localStorage.setItem('updateDate', "No");
    if (this.data && this.data[0]) {
      this.setData();
    } else if (this.dialogData && this.dialogData.header) {
      //**************  SG-7218 start *****************
      this.dataSource = new MatTableDataSource([]);
      this.dateType = this.dialogData.dateRange ? this.dialogData.dateRange : { type: 'day' };
      this.getData(this.dateType, true);
      //**************  SG-7218 end *****************

    } else {
      this.message = 'No data found';
    }
  }

  openUserDialog(element) {
    this.rowClicked.emit(element);
  }
  // ***************** SG-7046 start ***********

  async onPageChange(event: PageEvent) {
    this.pageSize = event.pageSize;
    // this.paginateDate();
    for (let i = 0; i < this.data.length; i++) {
      if (this.data[i].email) {
        this.data[i].emailDec = await this.crypto.decryptData(this.data[i].email);
      }

      if (this.data[i].username) {
        this.data[i].usernameDec = await this.crypto.decryptData(this.data[i].username);
      }
    }
    this.dataSource = new MatTableDataSource(this.data);
    this.dataSource.paginator = this.paginator;


  }
  // ***************** SG-7046 end ***********

}//SG-7046 end
